import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type DriftType = 'overcall_rising' | 'approval_dropping' | 'confidence_inflation' | 'override_spike';
export type Severity = 'low' | 'medium' | 'high';

export interface Drift {
  drift_type: DriftType;
  severity: Severity;
  affected_systems: string[];
  current_value: number;
  baseline_value: number;
  change_percent: number;
  message: string;
}

export interface DriftData {
  drifts: Drift[];
  last_checked: string;
  has_alerts: boolean;
}

export function useDviDrift(shopId: string | null, trendWindowDays: number = 30) {
  return useQuery({
    queryKey: ['dvi-drift', shopId, trendWindowDays],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('dvi-detect-pattern-drift', {
        body: { shop_id: shopId, trend_window_days: trendWindowDays }
      });
      if (error) throw error;
      return data as DriftData;
    },
    enabled: !!shopId,
    staleTime: 1000 * 60 * 60 * 6, // 6 hours
  });
}
